import { useState, useEffect } from "react";

export type Breakpoint = "phone" | "tablet" | "desktop";

const PHONE_MAX = 767;   // < 768 = phone
const TABLET_MAX = 1023; // 768–1023 = tablet, >= 1024 = desktop

export function useBreakpoint(): Breakpoint {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>(() => {
    if (typeof window === "undefined") return "desktop";
    const w = window.innerWidth;
    if (w <= PHONE_MAX) return "phone";
    if (w <= TABLET_MAX) return "tablet";
    return "desktop";
  });

  useEffect(() => {
    const phoneMq = window.matchMedia(`(max-width: ${PHONE_MAX}px)`);
    const tabletMq = window.matchMedia(`(min-width: 768px) and (max-width: ${TABLET_MAX}px)`);

    function update() {
      if (phoneMq.matches) setBreakpoint("phone");
      else if (tabletMq.matches) setBreakpoint("tablet");
      else setBreakpoint("desktop");
    }

    phoneMq.addEventListener("change", update);
    tabletMq.addEventListener("change", update);
    return () => {
      phoneMq.removeEventListener("change", update);
      tabletMq.removeEventListener("change", update);
    };
  }, []);

  return breakpoint;
}
